import React from 'react'

function TenderTextKLETEETM() {
  return (
    <embed src="\pdfs\EA2.2.3-4_kl-ete_etm_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextKLETEETM